// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"380":"cf79d70a","917":"d93d0c28","994":"679016dd"}[chunkId] + ".css";
};